
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, TrendingUp, Activity, Target } from 'lucide-react';

interface CourierMetricsCardProps {
  totalCouriers: number;
  activeRepeatCouriers: number;
  averageRepeatedPayments: number;
  topCourierPayments: number;
}

const CourierMetricsCard: React.FC<CourierMetricsCardProps> = ({
  totalCouriers,
  activeRepeatCouriers,
  averageRepeatedPayments,
  topCourierPayments
}) => {
  const repeatPercentage = totalCouriers > 0 ? (activeRepeatCouriers / totalCouriers * 100) : 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Users className="h-4 w-4 text-blue-500" />
            <div>
              <p className="text-2xl font-bold text-blue-600">{activeRepeatCouriers}</p>
              <p className="text-xs text-muted-foreground">Оплатило Курьеров</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <TrendingUp className="h-4 w-4 text-green-500" />
            <div>
              <p className="text-2xl font-bold text-green-600">{repeatPercentage.toFixed(1)}%</p>
              <p className="text-xs text-muted-foreground">% с повторными платежами</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Activity className="h-4 w-4 text-orange-500" />
            <div>
              <p className="text-2xl font-bold text-orange-600">{averageRepeatedPayments.toFixed(1)}</p>
              <p className="text-xs text-muted-foreground">Среднее повторных платежей</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Target className="h-4 w-4 text-purple-500" />
            <div>
              <p className="text-2xl font-bold text-purple-600">{topCourierPayments}</p>
              <p className="text-xs text-muted-foreground">Максимум у курьера</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CourierMetricsCard;
